export class CustomError<T> extends Error {
   errorData: T
   constructor(errorMessage: string, errorData: T) {
      super(errorMessage)

      this.errorData = errorData
   }
}
